import {KNOWN_CHAIN_CURRENCY} from "./libs/useMetaMaskWallet/utils";

const convertTokenToNFTDetails = (data) => ({
    id: data.id['S'],
    author: data.author['S'],
    source: data.source['S'],
    step: data.step['S'],
    wallet: data.wallet['S'],
    token_id: data.token_id['N'],
    inserted: data.inserted['N']
})

const convertTradingTokenToNFTDetails = (data) => ({
    id: data.id['S'],
    author: data.author['S'],
    source: data.source['S'],
    step: data.step['S'],
    wallet: data.wallet['S'],
    token_id: data.token_id['N'],
    inserted: data.inserted['N'],
    updated: data.updated['N'],
    price: data.price['N'],
})

const formatAddress = (address) => {
    return address.substring(0, 6) + "..." + address.substring(address.length - 4, address.length)
}

const formatBalance = (val, wallet) => {
    const float_val = val / 1000000000000000000
    let currency = "ETH"
    if (wallet) {
        currency = KNOWN_CHAIN_CURRENCY[wallet.ethereum.networkVersion]
    }
    return float_val.toFixed(2) + ` ${currency}`
}

export {
    convertTokenToNFTDetails,
    convertTradingTokenToNFTDetails,
    formatAddress,
    formatBalance
}